module.exports = __webpack_public_path__ + "img/pending_zone.3492c310.svg";